import { createContext } from "react";
import { ContextWithSetter } from "../util/contextWithSetter";

export interface AuthorizationContextValue {
  /** As with Authn context, this is true at initial load */
  shouldInitializeLoad: boolean;
  /** Gets set to true once we requested additional account data */
  finishedLoading: boolean;
  /**
   * The role is specific to the WebMap this is used in. Is undefined
   * before server responds with the information.
   */
  rolle?: string;
  /**
   * The secLevel is specific to the WebMap this is used in. Is undefined
   * before server responds with the information.
   */
  secLevel?: number;
}

export interface AuthorizationContextValueWithSetter
  extends AuthorizationContextValue,
    ContextWithSetter<AuthorizationContextValue> {}

/**
 * The Authorization context provides additional account data within a WebMap
 * (specifically, role and secLevel of the user).
 */
const AuthorizationContext = createContext<AuthorizationContextValueWithSetter>(
  {
    setContextValue: () => {}, // pass the react setter later
    shouldInitializeLoad: true,
    finishedLoading: false,
    rolle: undefined,
    secLevel: undefined,
  }
);

export default AuthorizationContext;
